"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../../constants/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Lightning = function Lightning(_ref) {
  var color = _ref.color,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "5",
    height: "12",
    viewBox: "0 0 5 12",
    fill: "none",
    className: className
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 6.93209C0.0165624 6.87628 0.0533675 6.80372 0.0717701 6.74605L3.03644 0.772093C3.38057 0.0744186 3.25359 0.293954 3.43577 0C3.3272 0.744186 2.87265 3.4493 2.59845 5.12C3.25359 5.12 4.34487 5.1014 5 5.1014C4.98325 5.13278 4.96482 5.16321 4.94479 5.19256L2.16231 10.8986C1.78138 11.6688 1.70777 11.853 1.61023 12C1.682 11.6279 1.9562 9.74326 2.22856 8.03721C2.30033 7.65209 2.28193 7.78046 2.41259 6.92093C1.58079 6.93209 1.30291 6.91721 0 6.93209Z",
    fill: color
  }));
};

Lightning.propTypes = {
  color: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Lightning.defaultProps = {
  color: _colors.MINE_SHAFT,
  className: null
};
var _default = Lightning;
exports["default"] = _default;